import {useEffect, useRef} from "react";
import {
  getDownShopListApi,
  getMeInfoApi,
  getOrderDeliverableAreaApi, getShopInfoApi, getShopOperateApi,
  getShopOriginApi
} from "../api/shopApi";
import {getCategoryApi} from "../api/categoryApi";
import {getUserInfo} from "../utils/CommonUtils";

export const useGetDownShopLIstApi = (setters, userType, userId, shopId) => {
  useEffect(() => {
    const response = async () => {
      if(userType && userId) {
        try {
          const data = await getDownShopListApi(userType, userId, shopId);

          setters.setShopId?.(data.shopId);
          setters.setShopName?.(data.shopName);
          setters.setShopList?.(data.shopList);
        } catch (e) {
          alert("상점정보를 조회할 수 없습니다.");
        }
      }
    }
    response();
  }, [userType, userId, shopId]);
}

// 주문 채널 매장 정보 조회
export const useShopInfo5Hook = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const deliverableAreaData = await getOrderDeliverableAreaApi(data);
        setters.setDeliverableAreaList?.(deliverableAreaData || []);
      } catch (e) {
        alert("에러가 발생했습니다.");
      }
    }

    if (data && JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }

  }, [data, setters]);
}

// 상점 원산지 조회
export const useGetShopOriginApi = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const shopData = await getShopOriginApi(data);
        setters.setList?.(shopData || []);
      } catch (e) {
        alert("에러가 발생했습니다.");
      }
    }

    if (data && JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }

  }, [data, setters]);
}

// 상점 원산지 조회
export const useGetMeInfoApi = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const shopData = await getMeInfoApi();
        setters.setMeInfo?.(shopData || null);
      } catch (e) {
        alert("에러가 발생했습니다.");
      }
    }

    if (data && JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }

  }, [data, setters]);
}

// 상점 원산지 조회
export const useGetShopInfoApi = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {accessToken} = getUserInfo();

        const response = await getShopInfoApi(data);
        const categoryResponse = await getCategoryApi(accessToken);
        let categoryList = [];
        response.categoryIds?.forEach((value) => {
          let filter = categoryResponse.find((category) => category.id === value);

          categoryList.push(filter.name);
        });

        let openTimeList = [];
        let breakTimeList = [];

        response.operateTimes?.forEach((value) => {
          if (value.type === 1) {
            openTimeList.push(value);
          } else {
            breakTimeList.push(value);
          }
        });

        openTimeList.sort(function(a, b) {
          return parseFloat(a.dayOfWeek) - parseFloat(b.dayOfWeek);
        });
        breakTimeList.sort(function(a, b) {
          return parseFloat(a.dayOfWeek) - parseFloat(b.dayOfWeek);
        });

        let startDay = null;
        let endDay = null;
        let shopTempId = null;

        if (response.tempHolidays && response.tempHolidays.length > 0) {
          startDay = response.tempHolidays[0].startDate;
          endDay = response.tempHolidays[0].endDate;
          shopTempId = response.tempHolidays[0].id;
        }

        let dongCostOutput = [];
        let dongCostList = [];
        let dongValueList = [];

        if (response.addressSurcharges && response.addressSurcharges.length > 0) {
          const dongCostData = response.addressSurcharges.sort(function(a, b) {
            return parseFloat(a.price) - parseFloat(b.price);
          });

          for(let i = 0; dongCostData.length > i; i++) {
            if(i === 0) {
              dongValueList.push(dongCostData[i].price)
            } else {
              if(dongCostData[i].price !== dongCostData[i - 1].price) {
                dongValueList.push(dongCostData[i].price)
              }
            }
          }

          dongCostList = dongCostData.reduce(function(a, b) {
            if(!a[b.price]) {
              a[b.price] = [b];
            } else {
              a[b.price] = a[b.price].concat(b);
            }
            return a;
          }, {});

          for(let i = 0; dongValueList.length > i; i++) {
            dongCostOutput.push(dongCostList[dongValueList[i]])
          }
        }

        response.deliveryPriceByOrderPrices?.sort(function(a, b) {
          return parseFloat(a.testOrderPrice) - parseFloat(b.testOrderPrice);
        });

        setters.setShopName?.(response.name);
        setters.setShopStatus?.(response.status);
        setters.setServiceType?.(response.serviceType);
        setters.setShopTel?.(response.tel);
        setters.setDeliveryType?.(response.deliveryTypes);
        setters.setDeliveryDoneMinutes?.(response.deliveryCompleteMinutes);
        setters.setBundleDoneMinutes?.(response.packingCompleteMinutes);
        setters.setIntro?.(response.intro);
        setters.setNotice?.(response.notice);
        setters.setLogoImage?.(response.imageUrl);
        setters.setNoticeImage?.(response.noticeImages);
        setters.setCategory?.(categoryList);
        setters.setPayTypeList?.(response.paymentTypes);
        setters.setFeeType?.(response.feeType);
        setters.setRoad?.(response.road);
        setters.setLat?.(response.lat);
        setters.setLng?.(response.lng);
        setters.setJibun?.(response.jibun);
        setters.setPackagingCost?.(response.packingDiscountPrice || 0);
        setters.setAddressDetail?.(response.addressDetail);
        setters.setMainImages?.(response.mainImages);
        setters.setOpenTimeList?.(openTimeList);
        setters.setBreakTimeList?.(breakTimeList);
        setters.setRoutineHolidays?.(response.routineHolidays);
        setters.setIsClosedOnLegalHoliday?.(response.isClosedOnLegalHoliday);
        setters.setStartDay?.(startDay);
        setters.setEndDay?.(endDay);
        setters.setDefaultStartDay?.(startDay);
        setters.setDefaultEndDay?.(endDay);
        setters.setShopTempId?.(shopTempId);
        setters.setDeliveryPriceCalculateType?.(response.deliveryPriceCalculateType);
        setters.setAddDist?.(response.distanceSurcharge?.testDistance || 0);
        setters.setAddDistCost?.(response.distanceSurcharge?.price || 0);
        setters.setFreeCostList?.(response.freeDeliveryPolicies || []);
        setters.setDongList?.(response.deliveryZones || []);
        setters.setDongExtraList?.(response.addressSurcharges || []);
        setters.setOutput?.(dongCostOutput);
        setters.setTimeExtraList?.(response.timeSurcharges || []);
        setters.setAddDistCost?.(response.distanceSurcharge?.price || 0);
        setters.setCostList?.(response.deliveryPriceByOrderPrices || []);
        setters.setWeatherSurchargePrice?.(response.weatherSurchargePrice || 0);
        setters.setWeatherSurchargeEnabled?.(response.weatherSurchargeEnabled);
        setters.setPauseStartDateTime?.(response.pauseStartDateTime);
        setters.setPauseEndDateTime?.(response.pauseEndDateTime);
        setters.setMinOrderCost?.(response.minOrderPrice);
      } catch (e) {
        console.log(e);
        alert("에러가 발생했습니다.");
      }
    }

    if (data && JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }

  }, [data, setters]);
}

// 상점 원산지 조회
export const useGetShopOperateApi = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const shopData = await getShopOperateApi(data);
        console.log(shopData);
        setters.setShopList?.(shopData.data || null);
      } catch (e) {
        alert("에러가 발생했습니다1.");
      }
    }

    if (data && JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }

  }, [data, setters]);
}


